import React from 'react'

export class GlobalErrorBoundary extends React.Component<React.PropsWithChildren, { error?: Error }> {
  constructor(props: React.PropsWithChildren) { super(props); this.state = {} }
  static getDerivedStateFromError(error: Error) { return { error } }
  async componentDidCatch(error: Error, info: React.ErrorInfo) {
    console.error('Global error boundary:', error, info)
    try {
      const dsn = (import.meta as any).env?.VITE_SENTRY_DSN
      if (dsn) {
        const Sentry = await import('@sentry/react')
        Sentry.captureException(error, { contexts: { react: { componentStack: info.componentStack } } })
      }
    } catch (reportError) {
      console.warn('Failed to report error to Sentry', reportError)
    }
  }
  render() {
    if (this.state.error) {
      return (
        <div className="min-h-screen flex items-center justify-center p-6">
          <div className="max-w-lg w-full rounded border p-6 bg-white dark:bg-gray-900">
            <div className="text-lg font-semibold mb-2">Something went wrong</div>
            <div className="text-sm text-gray-600 dark:text-gray-300 mb-4">{this.state.error.message}</div>
            <div className="flex gap-2">
              <button className="px-3 py-2 rounded border" onClick={() => location.reload()}>Reload</button>
              <button className="px-3 py-2 rounded border" onClick={() => this.setState({ error: undefined })}>Dismiss</button>
            </div>
          </div>
        </div>
      )
    }
    return this.props.children
  }
}
